import CurrencyProvider from './CurrencyProvider';

export default CurrencyProvider;
